
import React from "react";

const Hotel = () => {
  return (
    <div style={styles.container}>
      <iframe
        src="https://script.google.com/macros/s/AKfycbx6v0MUYPQC_m8EnixsZDVsytpua20yOt1MoLCxstdtaYf-EtdRO5O4pGuXy44X1D3axA/exec

"
        title="Attendance 5"
        style={styles.iframe}
      />
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    height: "100vh",
    overflow: "hidden", // 🚀 prevents double scroll
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
  },
};

export default Hotel;